import React, { Component } from "react";
import { Form, Input } from "formsy-react-components";
import PropTypes from "prop-types";
import { Navbar, Grid, Row, Col } from "react-bootstrap";

const axios = require("axios");

const auth = {
  isAuthenticated: localStorage.getItem("isAuthTurnos6") === "true",
  authenticate(cb) {
    this.isAuthenticated = true;
    localStorage.setItem("isAuthTurnos6", true);
    setTimeout(cb, 100);
  },
  signout(cb) {
    this.isAuthenticated = false;
    setTimeout(cb, 100);
  }
};

class Auth extends Component {
  state = {};

  constructor(props) {
    super(props);
    this.state = {
      user: {
        username: "",
        password: ""
      }
    };
  }

  submitForm = data => {
    axios
      .post("http://190.105.227.203/turnos/login", {
        user: data
      })
      .then(response => {
        if (response.data.error == 0) {
          auth.authenticate(() => {
            const expirationDate = new Date(
              new Date().getTime() + response.data.expiresIn * 1000
            );
            this.setState(() => ({
              token: response.data.token,
              redirectToReferrer: true,
              error: "",
              expirationDate: expirationDate
            }));

            localStorage.setItem("turnosToken", this.state.token);
            localStorage.setItem("turnosExpirationDate", expirationDate);

            this.props.OnLoginSucess(
              this.state.token,
              this.state.expirationDate
            );
          });
        } else {
          this.setState({ error: "Usuario/Contraseña incorrectas" });
        }
      })
      .catch(error => {});
  };

  render() {
    return (
      <React.Fragment>
        <Grid>
          <Row>
            <Col md={4} mdOffset={3}>
              <div className="row" style={{ marginTop: "100px" }}>
                <Form
                  layout="vertical"
                  validateOnSubmit={PropTypes.bool.true}
                  data={this.state.user}
                  onSubmit={this.submitForm}
                  className="col s3 offset-s4"
                >
                  <Input
                    type="text"
                    className="form-control"
                    label="Usuario"
                    name="usuario"
                    value={
                      this.state.user.username === null
                        ? ""
                        : this.state.user.username
                    }
                    required
                  />
                  <Input
                    type="password"
                    className="form-control"
                    label="Password"
                    name="password"
                    value={
                      this.state.user.password === null
                        ? ""
                        : this.state.user.password
                    }
                    required
                  />
                  <h6>
                    <label>{this.state.error}</label>
                    <br />
                    <button
                      type="submit"
                      className="btn btn-primary btn-lg btn_reg"
                      disabled={this.state.loading}
                    >
                      Login
                    </button>
                  </h6>
                </Form>
              </div>
            </Col>
          </Row>
        </Grid>
      </React.Fragment>
    );
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/containers/Auth.js